import React from "react";
import { useSelector } from "react-redux";
import Allergies from "../../service-steps/clinical-assessment/allergies";
import RedFlag from "../../service-steps/clinical-assessment/red-flag";
import DrugInduced from "../../service-steps/clinical-assessment/drug-induced";

const ClinicalAssessment = () => {
  const { clinicalServiceObj } = useSelector((state) => state.clinicalService);
  const { currentSubStep } =
    clinicalServiceObj.initialAssessment.initialAssessmentForm;

  const renderStep = () => {
    const subStep = currentSubStep;
    switch (subStep) {
      case 1:
        return <Allergies />;
      case 2:
        // Lifestyle is removed for Minor Ailment; keep legacy sub-step navigation compatible.
        return <RedFlag />;
      case 3:
        return <RedFlag />;
      case 4:
        return <DrugInduced />;
      default:
        return null;
    }
  };
  return renderStep();
};

export default ClinicalAssessment;
